export interface IStandaloneDetectionInput {
    displayModeMatchesStandalone: boolean;
    iosNavigatorStandalone: boolean | undefined;
    referrer: string;
}

/**
 * True when the app is running as an installed PWA / Home Screen app.
 */
export function isStandaloneDisplayMode({
    displayModeMatchesStandalone,
    iosNavigatorStandalone,
    referrer,
}: IStandaloneDetectionInput): boolean {
    if (displayModeMatchesStandalone) {
        return true;
    }

    if (iosNavigatorStandalone === true) {
        return true;
    }

    // Android TWA / some WebAPK launches
    if (/android-app:\/\//i.test(referrer)) {
        return true;
    }

    return false;
}

export function readStandaloneDisplayModeFromWindow(win: Window = window): boolean {
    const displayModeMatchesStandalone =
        typeof win.matchMedia === 'function' && win.matchMedia('(display-mode: standalone)').matches;

    const nav = win.navigator as Navigator & { standalone?: boolean };

    return isStandaloneDisplayMode({
        displayModeMatchesStandalone,
        iosNavigatorStandalone: nav.standalone,
        referrer: win.document.referrer || '',
    });
}
